<template>

    <div id="header">
        <nav class="navbar navbar-default navbar-fixed-top">

            <div class="container-fluid">

                <div class="navbar-header">

                    <div class="dropdown" id="dropdownAplicacao">
                        <a href="#" id="aplicacaoAtual" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                            <a href="#"><img src="../../static/images/home.png"></a>
                        </a>

                        <ul class="dropdown-menu" aria-labelledby="aplicacaoAtual" id="listaAplicacoes">
                            <li><a href="#"><img src="../../static/images/effect-advice.png" class="aplicacaoDisabled"></a></li>
                            <li><a href="#"><img src="../../static/images/effect-fidelity.png"></a></li>
                            <li><a href="#"><img src="../../static/images/effect-campaign.png"></a></li>
                            <li><a href="#"><img src="../../static/images/effect-mail.png"></a></li>
                            <li><a href="#"><img src="../../static/images/effect-page.png"></a></li>
                            <li><a href="#"><img src="../../static/images/effect-push.png"></a></li>
                            <li><a href="#"><img src="../../static/images/effect-reports.png"></a></li>
                            <li><a href="#"><img src="../../static/images/effect-sms.png"></a></li>
                            <li><a href="#"><img src="../../static/images/peoplescope.png"></a></li>
                        </ul>
                    </div>

                    <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
                        <span class="sr-only">Toggle navigation</span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                    </button>

                </div>


                <div id="navbar" class="navbar-collapse collapse">

                    <ul class="nav navbar-nav navbar-right">

                        <li id="headerAjuda">
                           
                        </li>

                        <li>

                            <select class="btn btn-info btn-sm" id="listaProjetos">
                                <option value="">Selecione</option>
                                <option value="1" selected>Caoa</option>
                                <option value="2">Drogasil</option>
                            </select>

                        </li> 

                        <li id="headerUsuario">
                            <div class="dropdown">
                                <a href="#" id="menuUsuario" class="user" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                    <i class="fa fa-user fa-3x" aria-hidden="true"></i><br />
                                    <span class="visible-xs">Perfil <span class="caret"></span></span>
                                </a>
                                <ul class="dropdown-menu" aria-labelledby="menuUsuario">
                                    <li><a href="#">Editar perfil</a></li>
                                    <li><a href="#">Configurações</a></li>
                                    <li role="separator" class="divider"></li>
                                    <li><a href="#">Sair</a></li>
                                </ul>
                            </div>
                        </li>

                    </ul>
                </div>
            </div>
        </nav>
    </div>

</template>

<style scoped>
    .fa-user {
        margin-top: 10px;
        margin-left: 15px;
    }
</style>

<script>
import config from '@/util/configuracao.js'

export default{
    name: 'menu-aplicacoes'
}
</script>

<style>
    #aplicacaoAtual{
        color: #00594d;
    }
</style>


// WEBPACK FOOTER //
// src/components/MenuAplicacoes.vue?6897c688